define.alias("shared/components/shared/post/secondary/hashtag-suggestions/tabs", "settings/components/shared/post/secondary/hashtag-suggestions/tabs");